import { render } from "./SuccessNotif.vue?vue&type=template&id=9c960220"
import script from "./SuccessNotif.vue?vue&type=script&lang=js"
export * from "./SuccessNotif.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/admin.23paskal.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__